import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconColumns(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={24} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H10C10.5523 20 11 19.5523 11 19V5C11 4.44772 10.5523 4 10 4H5ZM6 18V6H9V18H6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 5C13 4.44772 13.4477 4 14 4H19C19.5523 4 20 4.44772 20 5V19C20 19.5523 19.5523 20 19 20H14C13.4477 20 13 19.5523 13 19V5ZM15 6V18H18V6H15Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
